import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid gx-lg-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Signal list", -1)
const _hoisted_3 = {
  class: "btn-toolbar",
  role: "toolbar",
  "aria-label": "Signal Actions"
}
const _hoisted_4 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "List actions"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("button", {
  class: "btn btn-outline-primary",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#filters",
  "aria-expanded": "false",
  "aria-controls": "filters"
}, " Filters ", -1)
const _hoisted_6 = {
  class: "collapse",
  id: "filters",
  role: "toolbar",
  "aria-label": "Signal filters"
}
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "conversionFilter"
}, "Conversion", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "stateFilter"
}, "State", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "" }, null, -1)
const _hoisted_12 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "Filter actions"
}
const _hoisted_13 = { class: "panel" }
const _hoisted_14 = { "aria-label": "Page navigation" }
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = { class: "col-sm-2" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = {
  key: 0,
  class: "pagination justify-content-center"
}
const _hoisted_19 = {
  key: 1,
  class: "page-link"
}
const _hoisted_20 = { class: "col-sm-2" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "table-responsive" }
const _hoisted_23 = { class: "table table-striped" }
const _hoisted_24 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Conversion"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Seq"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "State"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Message"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "History")
  ])
], -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 0,
  class: "list-group"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList())),
          class: "btn btn-outline-primary"
        }, "Refresh"),
        _hoisted_5
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createVNode("select", {
          class: "form-select",
          "aria-label": "Conversion",
          "aria-describedby": "conversionFilter",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestFilter.ConversionStatus = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList()))
        }, [
          _hoisted_9,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions.Conversion, (item) => {
            return (_openBlock(), _createBlock("option", {
              key: item,
              value: item
            }, _toDisplayString(item), 9, ["value"]))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.requestFilter.ConversionStatus]
        ]),
        _hoisted_10,
        _withDirectives(_createVNode("select", {
          class: "form-select",
          "aria-label": "State",
          "aria-describedby": "stateFilter",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestFilter.State = $event)),
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getList()))
        }, [
          _hoisted_11,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions.State, (item) => {
            return (_openBlock(), _createBlock("option", {
              key: item,
              value: item
            }, _toDisplayString(item), 9, ["value"]))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.requestFilter.State]
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("button", {
          class: "btn btn-outline-primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getList()))
        }, "Apply"),
        _createVNode("button", {
          class: "btn btn-outline-secondary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearFiltersAndRefresh()))
        }, "Clear")
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("nav", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _withDirectives(_createVNode("select", {
              class: "form-select",
              "aria-label": "Results per page",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.requestPaging.Limit = $event)),
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getList()))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.requestPaging.Options, (item) => {
                return (_openBlock(), _createBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, ["value"]))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.requestPaging.Limit]
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            (_ctx.pageBounds)
              ? (_openBlock(), _createBlock("ul", _hoisted_18, [
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > _ctx.requestPaging.Limit && _ctx.requestPaging.Skip > 0 ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setPage('-1'))),
                      href: "#",
                      tabindex: "-1",
                      "aria-disabled": "true"
                    }, "Previous")
                  ], 2),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageBounds, (page) => {
                    return (_openBlock(), _createBlock("li", {
                      key: page.number,
                      class: ['page-item', page.current == true ? 'active' : '', page.number == 0 ? 'disabled' : '']
                    }, [
                      (page.number > 0)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "page-link",
                            href: "#",
                            onClick: ($event: any) => (_ctx.setPage(page.number))
                          }, _toDisplayString(page.number), 9, ["onClick"]))
                        : (_openBlock(), _createBlock("a", _hoisted_19, "…"))
                    ], 2))
                  }), 128)),
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > (_ctx.requestPaging.Limit + _ctx.requestPaging.Skip) ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setPage('+1')))
                    }, "Next")
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_20, [
            (_ctx.backendResponse.count > 0)
              ? (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(_ctx.requestPaging.Skip > 0 ? _ctx.requestPaging.Skip : 1) + " to " + _toDisplayString(Math.min(_ctx.requestPaging.Skip + _ctx.requestPaging.Limit, _ctx.backendResponse.count)) + " of " + _toDisplayString(_ctx.backendResponse.count), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode("table", _hoisted_23, [
        _hoisted_24,
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.backendResponse.items, (signal) => {
            return (_openBlock(), _createBlock("tr", {
              key: signal.id
            }, [
              _createVNode("td", null, [
                (signal.CorrelationEvent)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: '/sims/signal/' + signal.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(signal.CorrelationEvent.LatestReceiverStatus), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                (signal.InternalEvent)
                  ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(signal.InternalEvent.Initiator + " " + signal.InternalEvent.Class + " (" + signal.InternalEvent.Condition + ")"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("td", null, _toDisplayString(signal.ConversionStatus), 1),
              _createVNode("td", null, _toDisplayString(signal.Sequence+1), 1),
              _createVNode("td", null, _toDisplayString(signal.State), 1),
              (signal.CorrelationEvent)
                ? (_openBlock(), _createBlock("td", _hoisted_26, _toDisplayString(signal.CorrelationEvent.SourceEvent.Message), 1))
                : _createCommentVNode("", true),
              (signal.InternalEvent)
                ? (_openBlock(), _createBlock("td", _hoisted_27, _toDisplayString(signal.InternalEvent.Message), 1))
                : _createCommentVNode("", true),
              _createVNode("td", null, [
                (signal.CorrelationEvent)
                  ? (_openBlock(), _createBlock("ul", _hoisted_28, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(signal.CorrelationEvent.ReceiverAction, (event, index) => {
                        return (_openBlock(), _createBlock("li", {
                          class: ["list-group-item", ['list-group-item', event.Result ? 'list-group-item-success' : 'list-group-item-danger']],
                          key: index
                        }, [
                          _createTextVNode(_toDisplayString(event.ReceiverStatus) + " @ " + _toDisplayString(_ctx.getHumanDate(event.Generated)), 1),
                          (event.GeneratedArtefacts > 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_29, " " + _toDisplayString(event.GeneratedArtefacts) + " signals", 1))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (signal.InternalEvent)
                  ? (_openBlock(), _createBlock("span", _hoisted_30, "Generated @ " + _toDisplayString(_ctx.getHumanDate(signal.InternalEvent.Generated)), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}